"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCard = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../..");
const ActionCard_styles_1 = require("./ActionCard.styles");
const ActionCard_utils_1 = require("./ActionCard.utils");
const ActionCardActionButtons_1 = require("./components/actionButtons/ActionCardActionButtons");
const ActionCardBody_1 = require("./components/body/ActionCardBody");
const ActionCardHeader_1 = require("./components/header/ActionCardHeader");
const ActionCardBadge_1 = require("./components/header/badge/ActionCardBadge");
const ActionCardContentType_1 = require("./components/header/contentType/ActionCardContentType");
const ActionCardIcon_1 = require("./components/header/icon/ActionCardIcon");
const ActionCard = ({ children }) => {
    // N.B. We should either uncomment or delete this when we make
    // a decision on error-handling in the card
    // Check the children are only the correct types
    // React.Children.forEach(children, (child) => {
    //     checkChildrenAreValid(child, [
    //         "ActionCardHeader",
    //         "ActionCardBody",
    //         "ActionCardActionButtons",
    //     ]);
    // });
    // The children must contain a header and only one header
    (0, ActionCard_utils_1.checkContainsNumbersOfComponentChildren)({
        children,
        childName: "ActionCardHeader",
        minNumber: 1,
        maxNumber: 1,
    });
    // The children cannot contain more than 1 body
    (0, ActionCard_utils_1.checkContainsNumbersOfComponentChildren)({
        children,
        childName: "ActionCardBody",
        minNumber: 0,
        maxNumber: 1,
    });
    // The children must contain either no actionButtons component or only a single actionButtons component
    (0, ActionCard_utils_1.checkContainsNumbersOfComponentChildren)({
        children,
        childName: "ActionCardActionButtons",
        minNumber: 0,
        maxNumber: 1,
    });
    return (react_1.default.createElement(ActionCard_styles_1.StyledCard, null,
        react_1.default.createElement(__1.Card, { isElevated: false, spacing: 3, variant: "regular" }, children)));
};
exports.ActionCard = ActionCard;
exports.ActionCard.Header = ActionCardHeader_1.ActionCardHeader;
exports.ActionCard.Body = ActionCardBody_1.ActionCardBody;
exports.ActionCard.ActionButtons = ActionCardActionButtons_1.ActionCardActionButtons;
exports.ActionCard.Icon = ActionCardIcon_1.ActionCardIcon;
exports.ActionCard.ContentType = ActionCardContentType_1.ActionCardContentType;
exports.ActionCard.Badge = ActionCardBadge_1.ActionCardBadge;
exports.ActionCard.ActionButton = ActionCardActionButtons_1.ActionButton;
exports.ActionCard.ActionButtonLink = ActionCardActionButtons_1.ActionButtonLink;
//# sourceMappingURL=ActionCard.js.map